import type { AnalyticsEventName, AnalyticsPayload } from './events';

/**
 * The single seam between QuotyLab and any analytics vendor — deliberately
 * shaped like `StorageAdapter`, for the same reason: the application must never
 * know who is on the other side.
 *
 * There is no `identify`, no user id and no session stitching by design. This
 * interface cannot express "who did it", only "how often it happened".
 */
export interface AnalyticsAdapter {
  readonly id: string;
  track<T extends AnalyticsEventName>(event: T, payload: AnalyticsPayload<T>): void;
  /** Called when the user withdraws consent — must stop and forget. */
  shutdown(): void;
}

export class NoopAnalyticsAdapter implements AnalyticsAdapter {
  readonly id = 'noop';
  track(): void {}
  shutdown(): void {}
}

/** Development aid: prints what *would* have been sent. */
export class ConsoleAnalyticsAdapter implements AnalyticsAdapter {
  readonly id = 'console';

  track<T extends AnalyticsEventName>(event: T, payload: AnalyticsPayload<T>): void {
    console.info('[analytics]', event, payload);
  }

  shutdown(): void {}
}
